import { Modal, TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { configs } from '../../../assets/Config';
import '../../../assets/styles/RM.css'
import { uploadCompanyDataDoc } from '../../../services/apis/companyManagement/CMApi';
import { useLogin } from '../../../services/contexts/AdminLoginContext';
import { useCMContext } from '../../../services/contexts/companyManagement/CMContext';
import RichTextEditorPage from '../../includes/RichTextEditorPage';
import { useKYCContext } from '../../../services/contexts/KYCContext';
import { Autocomplete } from '@material-ui/lab';
import { upsertMandateRequest } from '../../../services/apis/shareManagement/BuyOrdersApi';
import { useBuyOrderContext } from '../../../services/contexts/BuyOrdersContext';
import { useRMContext } from '../../../services/contexts/RMContext';

export default function EditMandatePage() {

    const { setShowSuccess, token, logout, setLoginError, allowedFunc } = useLogin()
    const { getKYCVerifiedCustomer, kycVerifiedList } = useKYCContext()
    const { companyList } = useCMContext();
    const { getAllMandate, mandateData, setMandateData, editMandate, setEditMandate, activeStatus } = useBuyOrderContext();
    const { adminList, getAllAdmin } = useRMContext()

    const [companyId, setCompanyId] = useState("")
    const [customerId, setCustomerId] = useState("")
    const [customer, setCustomer] = useState("")
    const [quantity, setQuantity] = useState("")
    const [price, setPrice] = useState("")
    const [percent, setPercent] = useState("")
    const [comment, setComment] = useState("")
    const [remark, setRemark] = useState("")
    const [tokenAmount, setTokenAmount] = useState("")
    const [days, setDays] = useState("");
    const [status, setStatus] = useState("GENERATED")
    const [deal_done_by_admin_id, setdeal_done_by_admin_id] = useState("")
    const [error, setError] = useState("")

    useEffect(() => {
        if (editMandate) {
            try {
                setQuantity(mandateData.quantity)
                setPrice(mandateData.price_per_share)
                setPercent(mandateData.advance_percentage)
                setComment(mandateData.comment)
                setRemark(mandateData.remark)
                setStatus(mandateData.status)
                setdeal_done_by_admin_id(mandateData.deal_done_by || "")
                setTokenAmount(mandateData.token_amount)
                setDays(mandateData.mandate_time)
            } catch (error) {
                console.error(error);

            }
        }
    }, [editMandate])


    useEffect(() => {
        try {
            (async () => {
                getKYCVerifiedCustomer()
                getAllAdmin()
            })()

        } catch (error) {
            console.error(error)
        }
    }, [])

    const history = useHistory()


    // add company function
    async function updateMandate() {
        try {

            document.getElementById("companyBtn").classList.toggle("d-none")
            document.getElementById("companyBtnLoader").classList.toggle("d-none")

            if (editMandate && !mandateData.id) {
                setError("No valid mandate selected to udpate.")
            } else if (!editMandate && !customerId) {
                setError("Please select a valid customer.");
            } else if (!editMandate && !companyId) {
                setError("Please select a valid company.");
            } else if (!quantity) {
                setError("Please enter a valid quantity.");
            } else if (!price) {
                setError("Please enter a valid price.");
            } else if (!percent) {
                setError("Please select a valid percentage.")
            } else if (!tokenAmount) {
                setError("Please enter a valid token amount.")
            } else if (!days) {
                setError("Please enter a valid mandate timeline.")
            } else {
                const dealDoneByAdminId = deal_done_by_admin_id && typeof deal_done_by_admin_id === 'object' && deal_done_by_admin_id.id != null
                    ? deal_done_by_admin_id.id
                    : (typeof deal_done_by_admin_id === 'number' || (typeof deal_done_by_admin_id === 'string' && deal_done_by_admin_id !== ''))
                        ? deal_done_by_admin_id
                        : ""
                let response = await upsertMandateRequest(token, customerId, companyId, price, quantity, percent, comment, remark, tokenAmount, days, mandateData.id, status, dealDoneByAdminId)
                if (response && response.status === 200) {
                    resetValues()
                    setShowSuccess(true)
                    getAllMandate(configs.mandateStatusTypes[activeStatus].status, configs.startPage, configs.allRecordsFetchedTillNow, true)
                } else if (response && response.status === 401) {
                    logout()
                    setLoginError(configs.unauthorizedErrorMessage)
                } else {
                    setError(response.data.error)
                }
            }
            document.getElementById("companyBtn").classList.toggle("d-none")
            document.getElementById("companyBtnLoader").classList.toggle("d-none")
        } catch (error) {
            console.error(error);
        }
    }

    const resetValues = () => {
        try {
            // setCustomerId("");
            // setCompanyId("");
            setCustomer("");
            setQuantity("");
            setPrice("");
            setPercent("");
            setComment("");
            setRemark("");
            setError("");
            setStatus("GENERATED");
            setTokenAmount("");
            setDays("");
            setdeal_done_by_admin_id("");
            setEditMandate(false);
        } catch (error) {
            console.error(error);

        }
    }

    const handleNameChange = (e, value) => {
        try {
            setCustomer(value)
            setCustomerId(value.id)
            setdeal_done_by_admin_id(value.relationship_manager ? value.relationship_manager : "")
        } catch (error) {

        }
    }

    const handleRMChange = (e, value) => {
        try {
            setdeal_done_by_admin_id(value)
        } catch (error) {

        }
    }

    const handleCompanyChange = (e, value) => {
        try {
            setCompanyId(value.id)
        } catch (error) {

        }
    }

    // edit mandate ui code
    return (
        <div id="rmCreateCompany" className="col-lg-3 col-md-4 d-md-block d-none pt-3 main-rmPanel">
            <>
                <p className="h6 text-custom-grey">{editMandate ? "Edit Mandate Information" : "Create new Mandate"}</p>
                <form id="createRoleForm" action="" className='mr-1'>
                    {!editMandate ? <div className="form-group">
                        <label className="f-12">Select a customer</label>
                        {kycVerifiedList ? <Autocomplete
                            className="f-12"
                            id="emailIP"
                            placeholder="E-mail"
                            getOptionLabel={option => option && option.email ? `${option.name} - ${option.email}` : ""}
                            onChange={handleNameChange}
                            options={kycVerifiedList}
                            renderInput={(params) => <TextField {...params} placeholder="E-mail" className="f-12" onChange={getKYCVerifiedCustomer} />}
                        /> : null}
                    </div> : null}
                    {!editMandate ? <div className="form-group">
                        <label className="f-12">Select a Company</label>
                        {companyList ? <Autocomplete
                            className="f-12"
                            id="companyIP"
                            placeholder="Compnay Name"
                            getOptionLabel={option => option.name}
                            onChange={handleCompanyChange}
                            options={companyList}
                            renderInput={(params) => <TextField {...params} placeholder="Company Name" className="f-12" />}
                        /> : null}
                    </div> : null}
                    {/* {editMandate ?
                        <div className="form-group">
                            <label className="f-12">Select Status</label>
                            <select className="form-control f-10 py-2" placeholder="Status" value={status} onChange={(e) => {
                                setStatus(e.target.value)
                            }}>
                                <option value="GENERATED">Generated</option>
                                <option value="COMPLETED">Completed</option>
                                <option value="CANCELLED">Cancelled</option>
                            </select>
                        </div>
                        : null} */}
                    <div className="form-group">
                        <label>Quantity</label>
                        <input type="number" className="form-control f-10 py-2" placeholder="Qty" value={quantity} onChange={(e) => {
                            setQuantity(e.target.value)
                        }} />
                    </div>
                    <div className="form-group">
                        <label>Price per Share</label>
                        <input type="number" className="form-control f-10 py-2" placeholder="Price" value={price} onChange={(e) => {
                            setPrice(e.target.value)
                        }} />
                    </div>
                    <div className="form-group">
                        <label>Advance Percentage</label>
                        <input type="number" className="form-control f-10 py-2" placeholder="Advance Percentage" value={percent} onChange={(e) => {
                            setPercent(e.target.value)
                        }} />
                    </div>
                    <div className="form-group">
                        <label>Comment</label>
                        <input type="text" className="form-control f-10 py-2" placeholder="Comment" value={comment} onChange={(e) => {
                            setComment(e.target.value)
                        }} />
                    </div>
                    <div className="form-group">
                        <label>Remark</label>
                        <input type="text" className="form-control f-10 py-2" placeholder="Remark" value={remark} onChange={(e) => {
                            setRemark(e.target.value)
                        }} />
                    </div>
                    <div className="form-group">
                        <label>Token Amount</label>
                        <input type="text" className="form-control f-10 py-2" placeholder="Token Amount" value={tokenAmount} onChange={(e) => {
                            setTokenAmount(e.target.value)
                        }} />
                    </div>
                    <div className="form-group">
                        <label>Mandate Timeline (in Days)</label>
                        <input type="number" className="form-control f-10 py-2" placeholder="Mandate Timeline" value={days} onChange={(e) => {
                            setDays(e.target.value)
                        }} />
                    </div>
                    <div className="form-group">
                        <label>RM Name</label>
                        <input type="text" className="form-control f-10 py-2" value={(editMandate && mandateData?.user?.relationship_manager?.name) || (editMandate && mandateData?.relationship_manager?.name) || (customer && customer.relationship_manager && customer.relationship_manager.name) || ""} placeholder="RM Name" disabled />
                    </div>
                    <div className="form-group">
                        <label>Deal Done By Admin ID</label>
                        {adminList ? <Autocomplete
                            className="f-12"
                            id="dealDoneByMandate"
                            value={deal_done_by_admin_id ? deal_done_by_admin_id : ""}
                            placeholder="Admin Name"
                            getOptionLabel={option => option.name || ""}
                            onChange={handleRMChange}
                            options={adminList}
                            renderInput={(params) => <TextField {...params} placeholder="Manager Name" className="f-12" />}
                        /> : null}
                    </div>
                </form>
                <div className="form-check p-0">
                    <p className="text-danger" id="createRoleError">{error}</p>
                </div>
                <div className='row m-0 p-0'>
                    <div className='col-9 m-0 p-0'>
                        <button id="companyBtn" className="btn btn-primary f-12" onClick={(e) => {
                            e.preventDefault()
                            updateMandate()
                        }}>{editMandate ? "Update Mandate" : "Add Mandate"}</button>
                        <div id="companyBtnLoader" className='animBtn d-none'><div className='gSignIn-Anim'></div></div>
                    </div>
                    <div className='col-3 m-0 p-0'>
                        <button className="btn btn-primary f-12" onClick={(e) => {
                            e.preventDefault()
                            resetValues()
                        }}>Reset</button>
                    </div>
                </div>
                <div className='row m-0 p-0'>
                    <button className="btn btn-primary mt-3 d-md-none" onClick={(e) => {
                        e.preventDefault()
                        document.getElementById("rmCreateCompany").classList.toggle('d-none')
                        document.getElementById("companyListPage").classList.toggle('d-none')
                        history.push('/shareManagement/mandate')
                    }}>View All Mandate</button>
                </div>
            </>
        </div>
    )
}